module.exports = __webpack_public_path__ + "55b0313ab702899ae79d2ff5d3ec2293.png";